<template>
  <div>
    <router-link
      v-slot="{ href, navigate }"
      to="/settings/basics"
      class="flex text-gray-700 transition-colors duration-100 ease-out bg-gray-200 menu-item hover:text-orange-mia hover:bg-gray-300 group"
    >
      <a
        class="flex items-center justify-between flex-1 py-2 pl-3"
        :href="href"
        @click="navigate"
      >
        <div class="flex items-center">
          <mia-streamline-icon
            src="arrow-left-1"
            class="w-4 h-4 text-gray-500 transition-colors duration-100 ease-out fill-current icon group-hover:text-orange-mia"
          />

          <span class="ml-3">
            Zurück
          </span>
        </div>
      </a>
    </router-link>

    <mia-menu-item
      :to="{ name: 'settings.css.dispatch' }"
      icon="car-tool-keys"
      :progress="getPageProgress('dispatch')"
    >
      CSS
    </mia-menu-item>
    <mia-menu-item
      :to="{ name: 'settings.css.dunning' }"
      icon="file"
      :progress="getPageProgress('dunning')"
    >
      Mahnungen
    </mia-menu-item>
    <mia-menu-item
      :to="{ name: 'settings.css.saleschannel' }"
      icon="file"
      :progress="getPageProgress('saleschannel')"
    >
      Vertriebskanal
    </mia-menu-item>
    <mia-menu-item
      v-for="form in forms"
      :key="form.item_identifier"
      :to="'/settings/css/'+form.item_slug"
      :icon="form.item_icon"
      :progress="getPageProgress(form.item_identifier)"
    >
      {{ form.item_label }}
    </mia-menu-item>
  </div>
</template>

<script>
import get from 'lodash/get'
import { mapGetters } from 'vuex'
import MenuItem from '@/components/cars/edit/MenuItem.vue'

export default {
  components: {
    'mia-menu-item': MenuItem
  },

  props: {
    forms: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters('progress', ['progress'])
  },

  methods: {
    getPageProgress(page) {
      return get(this.progress, `css.page.${page}.progress`, 0)
    }
  }
}
</script>
